var React = require('react');

function OilCan (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M629.81 160.31L416 224l-50.49-25.24A64.2 64.2 0 0 0 336.9 192H176L37.72 166.86A31.93 31.93 0 0 0 0 198.34v95a32 32 0 0 0 26.28 31.48L96 337.46V384a32 32 0 0 0 32 32h274.64a32 32 0 0 0 22.76-9.51l212.26-214.75a8 8 0 0 0 2.34-5.66V168a8 8 0 0 0-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M592 288s-42.67 61.77-42.67 85.33a42.67 42.67 0 0 0 85.34 0C634.67 349.76 592 288 592 288zM336 96H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h56v48h48v-48h56a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

OilCan.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = OilCan;

OilCan.default = OilCan;
